import React, { useRef } from 'react';
import styles from './Hero.module.css';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function Hero({ onShowPopup }) {
  const heroRef = useRef(null);
  const textRef = useRef(null);
  const buttonRef = useRef(null);
  const imageRef = useRef(null);
  const bgRef = useRef(null);
  const cameraFrameRef = useRef(null);

    const handleLogin = () => {
    if (onShowPopup) {
      onShowPopup();
    } 
  };

  useGSAP(() => {
    if (!heroRef.current) return;
    
    gsap.fromTo(cameraFrameRef.current, 
      { opacity: 0, scale: 0.8 },
      { opacity: 1, scale: 1, duration: 1.5, ease: "expo.out", delay: 0.5 }
    );
    gsap.to(cameraFrameRef.current, {
      y: 160, 
      ease: "none",
      scrollTrigger: {
        trigger: heroRef.current,
        start: "top top",
        end: "top+=200 top",
        scrub: 0.2,
      }
    });

    // --- 1. GÉNÉRATION DES PARTICULES (BOUCLE PROPRE) ---
    const bgContainer = bgRef.current;
    const numberOfParticles = 40;

    for (let i = 0; i < numberOfParticles; i++) {
      const particle = document.createElement('div');
      particle.className = styles.particle;
      bgContainer.appendChild(particle);

      const size = gsap.utils.random(50, 200);
      
      gsap.set(particle, {
        width: size,
        height: size,
        x: gsap.utils.random(0, window.innerWidth),
        y: gsap.utils.random(0, window.innerHeight),
        opacity: gsap.utils.random(0.1, 0.5),
      });

      gsap.to(particle, {
        x: `+=100`,
        y: `+=100`,
        duration: gsap.utils.random(10, 20),
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: gsap.utils.random(0, 5),
      });
    }

    // --- 3. ANIMATIONS HERO (TEXTE & IMAGE) ---

    // Initialisation Image
    gsap.set(imageRef.current, {
      rotateX: 15,
      scale: 0.9,
      y: 50,
      transformOrigin: "top center"
    });

    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });
    
    tl.from(textRef.current.children, {
      y: 40,
      opacity: 0,
      duration: 1,
      stagger: 0.2,
    })
    .from(buttonRef.current, {
      scale: 0.8,
      opacity: 0,
      duration: 0.8,
    }, "-=0.5")
    .from(imageRef.current, {
      opacity: 0,
      duration: 1.5,
    }, "-=0.7");

    // Effet Scroll Image (AGNT style)
    gsap.to(imageRef.current, {
      rotateX: 0,
      scale: 1.1,
      y: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: heroRef.current,
        start: "top top",
        end: "top+=200 top",
        scrub: 1.6,
      }
    });
    gsap.to(buttonRef.current, {
      opacity:1,
    });

    const floatingAnim = gsap.to(imageRef.current, {
      y: "+=15",
      duration: 3,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut"
    });

    ScrollTrigger.create({
      trigger: heroRef.current, 
      start: "top top",
      onUpdate: (self) => {
        if (self.direction === 1) {
          floatingAnim.pause();
        } else if (self.scroll() === 0) {
          floatingAnim.play();
        }
      }
    });

  }, { scope: heroRef });

  return (
    <section ref={heroRef} id="hero" className={styles.hero}>
      <div ref={bgRef} className={styles.bgContainer}></div>
      <div ref={cameraFrameRef} className={styles.cameraFrame}>
        <div className={styles.cornerTL}></div>
        <div className={styles.cornerTR}></div>
        <div className={styles.cornerBL}></div>
        <div className={styles.cornerBR}></div>
      </div>
      <div className={styles.heroContainer}>
        
        <div ref={textRef} className={styles.heroContent}>
          <h3 className={styles.heroTitle}>
            Détection et Comptage <span className={styles.titleAccent}>Intelligent du Bétail</span> 
          </h3>
          <p className={styles.heroDescription}>
             Utilisez l'intelligence artificielle pour détecter, compter et analyser automatiquement votre bétail
            à partir d'images satellites et terrestres.
          </p>
        </div>

        <div className={styles.buttonContainer}>
          <button ref={buttonRef} className={styles.startButton} onClick={handleLogin}>
            Commencer maintenant
          </button>
        </div>

        <div className={styles.dashboardPreview}>
          <div ref={imageRef} className={styles.dashboardImage}>
            <img src="/images/hero.PNG" alt="Dashboard" className={styles.previewImg} />
          </div>
        </div>
        {/* --- AJOUT : LE PETIT CONTENEUR DESCRIPTIF EN BAS --- */}
        <div className={styles.bottomInfoWrapper}>
          <div className={styles.infoBox}>
            <h4>C'est quoi Sefcheptel ?</h4>
            <p>
              Sefcheptel est la plateforme tout-en-un pour la surveillance intelligente des troupeaux.
              Elle permet aux éleveurs et entreprises agricoles de déployer un système de comptage automatisé par espèce et par zone géographique, 
              offrant une précision totale sur votre domaine sans infrastructure lourde.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}